const countryCode = {
  USA: 'US',
  CANADA: 'CA',
};

export { countryCode };
